import createAxe from "../../middlewares/Axe";
import * as types from './actionTypes.js';
import { getTx } from "../dbActions";

export function getCommand(){
  return async function(dispatch, getState){
    let state = getState()

    if (!state){
      console.error('No state found')
      return
    }

    // There is a command already queued
    if(state.queue.command) {
      // we are not in a transaction
      if(!state.transaction.init) {
        let command = state.queue.command
        let args = state.queue.args
        dispatch(clearQueuedCommand())
        setTimeout(() => {
          processCommand(command, args, { state, dispatch })
        }, 2000)
      }
    }
    // there is no command in the queue -> try to get one (if exists)
    else {
      try {
        let axe = createAxe(state);
        let { status, data: { data } } = await axe('/boro/v2/RobotfaceQueue', {
          method: 'GET',
          headers: {
            'Atm-Token': `Bearer ${state.machine.atm_id}`,
          },
        })
        if(status == 200 && data.command) {
          // if we are in middle of a transaction, add the command to queue
          if(state.transaction.init) {
            return dispatch(queueCommand(data.command, data.args))
          }
          // if we are not in middle of a transaction, process it right away
          else {
            processCommand(data.command, data.args, { state, dispatch })
          }
        }
      }
      catch(error){
        return
      }
    }
  }
}

export function processCommand(command, args, { state, dispatch }) {
  switch(command){
    case 'RefreshApp':
      window.location.reload()
      break
    case 'PrintTx':
      let uuid = args
      dispatch(getTx(uuid))
      break
  }
}

export function clearQueuedCommand(){
  return{
    type: types.CLEAR_QUEUED_COMMAND
  }
}

export function queueCommand(command, args){
  return{
    type: types.QUEUE_COMMAND,
    command,
    args
  }
}